export default __webpack_public_path__ + "static/media/outlook.fb711e5f.svg";